/* @flow */
import * as React from "react";

import { Panel } from "react-bootstrap";
import { FsdAddressType } from "shared/src/types/customer/FsdAddress";
import { StoreType } from "../../../../datatypes/Store";

type Props = {
    address: FsdAddressType;
    onClick: any;
    selected: boolean | undefined | null;
    store: StoreType;
};

export function CustomerAddressBadgeWithStore(props: Props) {
    const address = props.address;
    const storeName = props.store.storeDisplayName;

    const mandatoryPanelClasses =
        "test-address-panel test-select-address-button panel-small sd-store-selection-option test-address-" +
        props.address.hash +
        " flexed-item--auto";

    const panelClasses = props.selected
        ? "panel-primary background-primary-reduced-more " + mandatoryPanelClasses
        : mandatoryPanelClasses;
    return (
        <Panel className={panelClasses} onClick={props.onClick}>
            <p className="big">
                <span className="text-brand">
                    <strong>{storeName}</strong>
                </span>
            </p>
            <p className="small">
                <span className="text-brand">
                    <i className="icon-delivery" />
                    &nbsp;
                    <strong>{address.street}</strong>
                    &nbsp;
                    <strong>{address.houseNumber}</strong>
                </span>
            </p>
        </Panel>
    );
}
